import script from "./CommonPlanCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonPlanCard.vue?vue&type=script&lang=ts&setup=true"

import "./CommonPlanCard.vue?vue&type=style&index=0&id=2ad8ba7c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad8ba7c"]])

export default __exports__